import React from 'react';
import { useLocation } from 'react-router-dom';

const EXACT_TITLES: Record<string, string> = {
  '/adminpanel': 'Dashboard',
  '/adminpanel/orders': 'Orders',
  '/adminpanel/users': 'Customers',
  '/adminpanel/products': 'Products',
  '/adminpanel/recipes': 'Recipes',
  '/adminpanel/coupons': 'Coupons',
  '/adminpanel/reviews': 'Reviews',
  '/adminpanel/settings': 'Settings',
  '/adminpanel/products/newProduct': 'New Product',
  '/adminpanel/recipes/new-recipe': 'New Recipe',
};

const PREFIX_TITLES: [string, string][] = [
  ['/adminpanel/orders/', 'Order'],
  ['/adminpanel/users/', 'Customer'],
  ['/adminpanel/products/', 'Edit Product'],
  ['/adminpanel/recipes/', 'Edit Recipe'],
  ['/adminpanel/coupons/', 'Coupon'],
];

const MainBar = ({ onMenuClick }: { onMenuClick: () => void }) => {
  const location = useLocation();
  const pageTitle =
    EXACT_TITLES[location.pathname] ??
    (PREFIX_TITLES.find(([prefix]) => location.pathname.startsWith(prefix))?.[1] ?? '');

  return (
    <div className="admin-content-header">
      <button className="admin-mobile-hamburger d-lg-none" onClick={onMenuClick}>
        <i className="fas fa-bars" style={{ fontSize: 20, color: '#202223' }} />
      </button>
      <h5 className="admin-content-title">{pageTitle}</h5>
    </div>
  );
};

export default MainBar;
